export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

export function showSnackbar(options) {
	return {
		type: SHOW_SNACKBAR,
		...options
	}
}

export function hideSnackbar() {
	return {
		type: HIDE_SNACKBAR
	}
}

export function handleShowSnackbar(options) {
	return dispatch => dispatch(showSnackbar(options));
}

export function handleHideSnackbar() {
	return dispatch => dispatch(hideSnackbar());
}



// WEBPACK FOOTER //
// ./src/actions/snackbar.js